<template>
  <div class="cutout__container">
    <ul class="table__header">
      <li class="num_type text-center">Place</li>
      <li class="rider_name">Rider</li>
      <li class="hidden-md">Horse</li>
      <li class="hidden-md">Owner</li>
      <li class="num_type">Score</li>
      <li class="num_type">$</li>
    </ul>
    <ul
      v-for="result in results"
      :key="result.id"
      class="table__body"
    >
      <li class="num_type">{{ result.place }}</li>
      <li class="rider_name">
        <strong>{{ result.rider }}</strong><small v-if="result.riderDeleted" class="text-primary ml-1">(deleted)</small>
        <div class="display-md"><strong>Horse: </strong>{{ result.horse }}<small v-if="result.horseDeleted" class="text-primary ml-1">(deleted)</small></div>
        <div class="display-md"><strong>Owner: </strong>{{ result.owner }}</div>
      </li>
      <li class="hidden-md">{{ result.horse }}<small v-if="result.horseDeleted" class="text-primary ml-1">(deleted)</small></li>
      <li class="hidden-md">{{ result.owner }}</li>
      <li class="num_type text-left">{{ result.score }}</li>
      <li class="num_type text-left">{{ result.payout }}</li>
    </ul>
    <strong class="total_payouts">
      <span>Total Payouts: </span>
      <span>${{ totalPayouts }}</span>
    </strong>
  </div>
</template>

<script>
import { defineComponent } from '@vue/composition-api'

export default defineComponent({
  name: 'PrizesResultsTable',
  props: {
    results: { type: Array, default: () => [] },
    totalPayouts: { type: String, default: '0.00' }
  }
})
</script>



// WEBPACK FOOTER //
// src/components/Prizes/PrizesResultsTable.vue